/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/window.d.ts" />

/**
 * Stream Pipe service
 */

namespace Application.Services {
    'use strict';
    
    import StreamPipe = Models.StreamPipe;
    import IStreamPipe = Models.IStreamPipe;
    import HalConverter = Models.HalConverter;
    import IHalList = Models.IHalList;
    import StreamPipeBlockConnectionInfo = Models.StreamPipeBlockConnectionInfo;
    import IGridMonitorScope = Application.Directives.IGridMonitorScope;
    import BlockTypeNaturalKey = Application.Models.BlockTypeNaturalKey;

    /**
     * StreamPipeService
     */
    export class StreamPipeService {
        public static $name: string = "streamPipeService";
        public static $inject: string[] = ['backendService',
                                           '$timeout',
                                           '$q',
                                            'blockService','aclService','deviceGuiService','$sce'];

        private static maxRequestWait: number = 100;

        private requestQueueLength: number = 5;
        private backendBaseUrl: string = window.backendUrl;
        // private servicePath: string = 'nodehealth/';
        private servicePath: string = '';
        private backendUrl: string = this.backendBaseUrl + this.servicePath + 'streamPipes';
        private pipeViewUrl: string = this.backendBaseUrl + this.servicePath + 'pipeviews/';
        private mvpMonitorUrl: string = this.backendBaseUrl + this.servicePath + 'mvpadapter/monitor/';
        private streamPipeBlockConnections: string = this.backendBaseUrl + this.servicePath + 'streamPipeBlockConnections';
        private searchStreamPipeByStreamIdUrl: string = this.streamPipeBlockConnections + '/search/findByStreamPipe?pipeStreamId=';
        private searchStreamPipesByDestinationBlockId: string =
            this.backendUrl + '/search/findStreamPipesByDestinationBlockId?destination=';
        private requestQueue: IdDeferredRequestMap;
        private requestQueueTimer: ng.IPromise<void>;
        public streamPipeToSrtCache: {[streampipe: string]: string[]} = {};
        private loading: boolean = false

        constructor(private backendService: Services.BackendService,
                    private $timeout: ng.ITimeoutService,
                    private qService: ng.IQService,
                    private blockService: Services.BlockService,
                    private aclService: Services.AclService,
                    private deviceGuiService: Services.DeviceGuiService,
                    private $sce: ng.ISCEService
        ) {
            this.requestQueue = {};
        }

        public async getSrtInPipe(streamPipe: IStreamPipe): Promise<string[]> {
            if (streamPipe) {
                const href: string = streamPipe.href.split('/').pop();
                if (!this.streamPipeToSrtCache[href]) {
                    this.loading = true;
                    let streamPipeBlockConnections: Models.IStreamPipeBlockConnectionInfo[] = await this.getStreamPipeBlockConnectionsByStreamId(parseInt(href.split('/').pop()));
                    streamPipeBlockConnections = streamPipeBlockConnections
                        .filter((blockConn: Models.IStreamPipeBlockConnectionInfo) =>
                            (blockConn.destBlock.blockTypeNaturalKey === BlockTypeNaturalKey.SRT_GW_TX_LSTN) || (blockConn.destBlock.blockTypeNaturalKey === BlockTypeNaturalKey.SRT_GW_RX_LSTN));
                    let auxMap = [];
                    for (const blockConn of streamPipeBlockConnections) {
                        const blockId = blockConn.destBlock.id;
                        const blockHref = 'blocks/' + blockId;
                        const node = await this.blockService.getNodeFromBlockId(blockId);
                        const nodeHref = 'networkNodes/' + node.id;
                        auxMap.push(nodeHref);
                        auxMap.push(blockHref);
                    }
                    this.streamPipeToSrtCache[href] = auxMap;
                    this.loading = false;
                    return this.streamPipeToSrtCache[href];
                }
                return this.streamPipeToSrtCache[href];

            }
            else {
                return [];
            }
        }

        public getStreamPipe(elementHref: string, showErr: boolean = true): ng.IPromise<IStreamPipe | ngCustom.IReason> {
            let id: number = Common.Utils.idFromHref(elementHref);
            let request: DeferredRequest = this.getOrCreateNewRequest(id, this.requestQueue);
            return request.deferred.promise;
        }

        public getStreamPipesByBlockList(blockIds: number[]): ng.IPromise<IStreamPipe[][]> {
            const blockListURL: string = this.backendUrl + '/blockList';
            return this.backendService
                .post(blockListURL, {"ids": blockIds})
                .then((res: ng.IHttpPromiseCallbackArg<Models.IHalElement<IStreamPipe>[][]>) => {
                    const halElementLists: Models.IHalElement<StreamPipe>[][] = res.data;
                    return halElementLists.map((halElementList: Models.IHalElement<StreamPipe>[]) => 
                        halElementList.map((halElement: Models.IHalElement<StreamPipe>) =>
                            halElement ? HalConverter.convertElement(halElement, StreamPipe.Empty) : undefined
                        )
                    )
                });
        }

        public getStreamPipeBlockConnectionsByStreamId(elementId: number): ng.IPromise<Models.IStreamPipeBlockConnectionInfo[]> {
            return this.backendService
                .get(this.searchStreamPipeByStreamIdUrl + elementId.toString())
                .then((res: ng.IHttpPromiseCallbackArg<Models.IHalList<Models.IStreamPipeBlockConnectionInfo>>) => {
                    let halList: Models.IHalList<Models.IStreamPipeBlockConnectionInfo> = res.data;
                    let converted: Models.StreamPipeBlockConnectionInfo[] =
                        Models.HalConverter.convertList(halList, StreamPipeBlockConnectionInfo.Empty);
                    return converted;
                });
        }

        public getStreamPipeViewByStreamId(elementId: number): ng.IPromise<Models.IStreamPipeElement[]> {
            return this.backendService
                .get(this.pipeViewUrl + elementId.toString())
                .then((res: ng.IHttpPromiseCallbackArg<Models.IStreamPipeElement[]>) => {
                    for (let element of res.data) {
                        element.networkNodeI.href = (element.networkNodeI as any).links[0].href; // tslint:disable-line
                        let nnt: Models.INetworkNodeType = new Models.NetworkNodeType();
                        nnt.href = (element.networkNodeI as any).links[1].href; // tslint:disable-line
                        nnt.id=element.networkNodeI.networkNodeTypeId;
                        element.networkNodeI.type = nnt;
                    }
                    return res.data;
                });
        }

        public getStreamPipeNodesHrefByStreamId(elementId: number): ng.IPromise<Models.IStreamPipeNodes> {
            return this.backendService
                .get(this.backendUrl + '/' + elementId + '/nodes')
                .then((res: ng.IHttpPromiseCallbackArg<Models.IStreamPipeNodes>) => {
                    return res.data;
                });
        }

        public getStreamPipeByDestinationBlockIdPromise(destBlockId: number): ng.IPromise<IStreamPipe[]> {
            return this.backendService
                .get(this.searchStreamPipesByDestinationBlockId + destBlockId)
                .then((res: ng.IHttpPromiseCallbackArg<IHalList<StreamPipe>>) => {
                    let halElement: IHalList<StreamPipe> = res.data;
                    let converted: IStreamPipe[] = HalConverter.convertList(halElement, StreamPipe.Empty);
                    return converted;
                });
        }

        public setRequestQueueLength(length: number): void {
            this.requestQueueLength = length;
            let size: number = Object.keys(this.requestQueue).length;
            if (size >= this.requestQueueLength ) {
                this.doMakeRequests();
            }
        }


        private getOrCreateNewRequest(id: number, idMap: IdDeferredRequestMap): DeferredRequest {
            if (idMap[id] === undefined) {
                idMap[id] = [];
            }
            let requests: DeferredRequest[] = idMap[id];
            let streamPipeRequest: DeferredRequest =
                new DeferredRequest(id, this.qService.defer());
            requests.push(streamPipeRequest);

            let size: number = Object.keys(idMap).length;
            if (size >= this.requestQueueLength ) {
                this.doMakeRequests();
            } else {
                if (!this.requestQueueTimer) {
                    this.requestQueueTimer = this.$timeout(() => {
                        // if we go over max time without reaching the desired length, request anyway
                        this.doMakeRequests();
                        this.requestQueueTimer = undefined;
                    }, StreamPipeService.maxRequestWait);
                }
            }

            return streamPipeRequest;
        }

        /**
         * check if blocks are being use in a connection
         * @param blockIds string of blocks id to check format :  (1-2)
         */
        public async isInUse(blockIds: string): Promise<boolean>{
            let aux = blockIds.split('-').map(Number);
            let res= await this.getStreamPipesByBlockList(aux);

            return res.some( (element) => {
                return element.length > 0;
            });
          }

        private doMakeRequests(): void {
            let tmpRequestQueue: IdDeferredRequestMap = this.requestQueue;
            this.requestQueue = {};
            if (Object.keys(tmpRequestQueue).length > 0)
                this.getStreamPipeListPromise(tmpRequestQueue, this.backendUrl + "/list" );
        }

        private getStreamPipeListPromise(requestMap: IdDeferredRequestMap, url: string): void {
            let ids: number[] = Object.keys(requestMap).map((value: string) => {
                return parseInt(value, 10);
            });
            let requests: DeferredRequest[][] = ids.map((id: number) => {
                return requestMap[id];
            });
            this.backendService.post(url, {"ids": ids})
                .then((result: ng.IHttpPromiseCallbackArg<Models.IHalElement<StreamPipe>[]>) => {
                    let videoFeeds: Models.IHalElement<StreamPipe>[] = result.data;
                    videoFeeds.forEach((halElement: Models.IHalElement<StreamPipe>, index: number) => {
                        if (halElement) {
                            let streamPipe: StreamPipe = HalConverter.convertElement(halElement, StreamPipe.Empty);
                            let requestsForIndex: DeferredRequest[] = requests[index];
                            requestsForIndex.forEach((request: DeferredRequest) => {
                                request.deferred.resolve(streamPipe);
                            });
                        } else {
                            let requestsForIndex: DeferredRequest[] = requests[index];
                            requestsForIndex.forEach((request: DeferredRequest) => {
                                request.deferred.reject();
                            });
                        }
                    });
                });
        }

        public setMvpMonitorUrl(blockId: number, srtUrl: string): any {
            return this.backendService
            .simplePost(this.mvpMonitorUrl + 'setMonitorUrl/' + blockId, srtUrl)
            .then((res: any) => {
                return res.data;
            });
        }

        public unsetMvpMonitorUrl(blockId: number): any {
            return this.backendService
            .simplePost(this.mvpMonitorUrl + 'unsetMonitorUrl/' + blockId, '')
            .then((res: any) => {
                return res.data;
            });
        }

        async getGrafanaUrl(pipeElement:Models.IStreamPipeElement): Promise<string|undefined> {

            const deviceUrl: Models.DeviceGui = await this.deviceGuiService.getDeviceGuiByBlockId(
                pipeElement.blockId.toString()
              )
            
            const canAccess: boolean=await this.aclService.canAccessGui(Number(pipeElement.networkNodeI.id))
              if (canAccess) {
                const url =this.$sce.trustAsResourceUrl(deviceUrl.guiUrl)
                return Promise.resolve(url as string);
              } else {
                return Promise.resolve(undefined);
              }
        }
    }
}
